import React from 'react';
import {BrowserRouter, Redirect, Route, Switch, withRouter} from 'react-router-dom';
import Raven from 'raven-js';
import Cookies from 'js-cookie';

import {StreetTeamApp} from './street-team/StreetTeamApp';

import {firebase, db} from './firebase';
import {LoginPage} from './LoginPage';
import {LogoutPage} from './LogoutPage';
import {page as analytics_page, identify as analytics_identify, reset as analytics_reset} from './analytics';

const CurrentUserContext = React.createContext({
  currentUser: null,
  loginUser: () => null,
  logoutUser: () => null
});

class _App extends React.Component {
  componentDidMount() {
    this.unlisten = this
      .props
      .history
      .listen(() => {
        analytics_page();
      });
  }

  componentWillUnmount() {
    this.unlisten()
  }

  render() {
    return this.props.children;
  }
}

const App = withRouter(_App);

const SkipRoutes = ({userDoc, signedIn}) => {
  let routesComponent;

  if (!signedIn) {
    routesComponent = (
      <Switch>
        <Route path="/login" component={LoginPage}/>
        <Redirect from="*" to="/login"/>
      </Switch>
    )
  } else {
    const isStreetTeam = userDoc && userDoc.data() && userDoc.data().streetTeam;

    routesComponent = (
      <Switch>
        <Route path="/login" component={LoginPage}/>
        <Route path="/logout" component={LogoutPage}/>

        {(isStreetTeam) ? (
          <Redirect exact={true} from='/' to='/map' />
        ) : (
          <Redirect exact={true} from='/' to='/onboarding' />
        )}

        <Route path="/" component={StreetTeamApp}/>
      </Switch>
    );
  }

  return (
    <App>{routesComponent}</App>
  )
};

const trySignInWithSsoCookie = async () => {
  const ssoToken = Cookies.get('ssoToken');
  if (!ssoToken) {
    return null;
  }

  Cookies.remove('ssoToken');
  const userCredential = await firebase.auth().signInWithCustomToken(ssoToken);
  const {user} = userCredential;
  return user;
}

class Router extends React.Component {
  constructor(props) {
    super(props);

    this.loginUser = (user, userDoc = null) => {
      analytics_identify(user.uid, {email: user.email});
      this.setState({currentUser: user, userDoc})
    }

    this.logoutUser = async() => {
      analytics_reset()
      await firebase
        .auth()
        .signOut();
      this.setState({currentUser: null, userDoc: null})
    }

    this.state = {
      currentUser: null,
      loginUser: this.loginUser,
      logoutUser: this.logoutUser,

      isLoadingUser: true,

      hasError: false,
    };
  }

  componentDidMount = async () => {
    // Listen to the Firebase Auth state and set the local state.
    const ssoUser = await trySignInWithSsoCookie();

    // If the user is already signed in, we will need to get the authUser and the doc from /users
    if (ssoUser) {
      this.loginUser(ssoUser);

      const {uid: userId} = ssoUser;
      this.setUpUserDocListener(userId);
    } else {
      this.unregisterAuthObserver = firebase
        .auth()
        .onAuthStateChanged(async (user) => {
          if (user) {
            this.loginUser(user)
            this.setUpUserDocListener(user.uid);
          } else {
            this.setState({isLoadingUser: false});
          }
        });
    }
  }

  setUpUserDocListener = (userId) => {
    db.collection('/users').doc(userId).onSnapshot((userDoc) => {
      this.setState({
        userDoc,
        isLoadingUser: false,
      })
    })
  }

  componentWillUnmount() {
    // Make sure we un-register Firebase observers when the component unmounts.
    if (this.unregisterAuthObserver) {
      this.unregisterAuthObserver();
    }
  }

  componentDidCatch(error) {
    this.setState({hasError: true});
    Raven.captureException(error);
  }

  render() {
    const {isLoadingUser, hasError, userDoc, currentUser} = this.state;

    if (hasError) {
      return (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p>
                I'm sorry, there was an error. Try refreshing to reload.
              </p>

              <p>
                If you keep running into this issue, email {' '}
                <a href="mailto:support@skipscooters.com">support@skipscooters.com</a>.
              </p>
            </div>
          </div>
        </div>
      )
    }

    if (isLoadingUser) {
      return <div>Loading...</div>
    }

    return (
      <CurrentUserContext.Provider value={this.state}>
        <BrowserRouter basename="/street-team">
          <SkipRoutes userDoc={userDoc} signedIn={!!currentUser}/>
        </BrowserRouter>
      </CurrentUserContext.Provider>
    );
  }
}

export {Router, CurrentUserContext};



// WEBPACK FOOTER //
// ./src/Router.js